import React from "react";
import { Card, Header, Icon, Label, List } from "semantic-ui-react";
import { careerStageOptions, expertiseKeywordsOptions, expertiseThematicOptions, investigatorYourResearchGroupOptions } from "../../../constants";
import { capitalizeFirstLetter } from "../../../utils/utils";

export const Expertise = ({ profile }) => {
    const TRLLevel = profile?.trl_level ? profile.trl_level : [];
    const areasOfExpertise = profile?.areas_of_expertise ? profile.areas_of_expertise : [];
    const mainKeywords = profile?.main_keywords ? profile.main_keywords : [];
    const additionalKeywords = profile?.additional_keywords ? JSON.parse(profile.additional_keywords) : [];

    return (
        <Card fluid>
            <Card.Content>
                <Card.Header as="h2">Expertise</Card.Header>

                {profile?.career_stage && (
                    <div style={{ display: "flex", paddingTop: "1rem", flexDirection: "row", gap: "1rem" }}>
                        <Header as="h4">Career Stage:</Header>
                        <p>{careerStageOptions.find((careerStage) => careerStage.key === profile.career_stage)?.text ?? ""}</p>
                    </div>
                )}

                {TRLLevel.length > 0 && (
                    <>
                        <Header as="h4">TRL Levels:</Header>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
                            {TRLLevel.map((itTRLLevel) => {
                                return <Label key={itTRLLevel}>{capitalizeFirstLetter(itTRLLevel)}</Label>;
                            })}
                        </div>
                    </>
                )}

                {areasOfExpertise.length > 0 && (
                    <>
                        <Header as="h4">Area(s) of Expertise:</Header>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
                            {areasOfExpertise.map((userExpertiseThematic) => {
                                return (
                                    <Label
                                        as='a'
                                        key={userExpertiseThematic}
                                        target='_blank'
                                        href={'/persons/search?q=user_profile.profile.areas_of_expertise%3A'+userExpertiseThematic}>
                                        {capitalizeFirstLetter(userExpertiseThematic)}
                                    </Label>
                                );
                            })}
                        </div>
                    </>
                )}

                {(additionalKeywords.length + mainKeywords.length > 0) && (
                    <>
                        <Header as="h4">Keywords</Header>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
                            {mainKeywords?.map((userExpertiseKeyword) => {
                                const aKeyword = userExpertiseKeyword.trim();
                                return (
                                <Label
                                    as='a'
                                    key={aKeyword}
                                    target='_blank'
                                    href={'/persons/search?q=user_profile.profile.main_keywords%3A'+aKeyword}>
                                    {capitalizeFirstLetter(aKeyword)}
                                </Label>
                                );
                            }
                            )}

                            {additionalKeywords?.map((k) => {
                                const aKeyword = k.trim();
                                return (
                                    <Label
                                        as='a'
                                        key={aKeyword}
                                        target='_blank'
                                        href={'/persons/search?q=user_profile.profile.additional_keywords%3A'+aKeyword}>
                                        {capitalizeFirstLetter(aKeyword)}
                                    </Label>
                                );
                            }
                            )}
                        </div>
                    </>
                )}
            </Card.Content>
        </Card>
    );
};
